/**
 * `offline_state` store — persists the `offlineSince` timestamp used by
 * NetworkStatusContext for the offline time-limit feature (API-4377).
 *
 * The underlying database connection and schema live in `offlineDb.ts`,
 * shared with the punch queue (`offlinePunchQueue.ts`) and LDR cache
 * (`ldrCache.ts`) added in API-4378.
 *
 * These operations fail soft (log + resolve) rather than throw, since
 * losing this persistence should never block offline detection from
 * working in-memory (e.g. private browsing modes that restrict IndexedDB).
 */

import { OFFLINE_STATE_STORE, getValue, setValue, deleteValue } from './offlineDb';

const OFFLINE_SINCE_KEY = 'offlineSince';

export async function getOfflineSince(): Promise<Date | null> {
    try {
        const iso = await getValue<string>(OFFLINE_STATE_STORE, OFFLINE_SINCE_KEY);
        return iso ? new Date(iso) : null;
    } catch (err) {
        console.error('[offlineStorage] Failed to read offlineSince', err);
        return null;
    }
}

export async function setOfflineSince(date: Date): Promise<void> {
    try {
        await setValue(OFFLINE_STATE_STORE, OFFLINE_SINCE_KEY, date.toISOString());
    } catch (err) {
        console.error('[offlineStorage] Failed to persist offlineSince', err);
    }
}

export async function clearOfflineSince(): Promise<void> {
    try {
        await deleteValue(OFFLINE_STATE_STORE, OFFLINE_SINCE_KEY);
    } catch (err) {
        console.error('[offlineStorage] Failed to clear offlineSince', err);
    }
}
